import { nodeListToArray } from './util';

let singleCarousel = (function() {
  let carousels = document.querySelectorAll('.single-carousel');
  carousels = nodeListToArray(carousels);

  let init = () => {
    carousels.forEach(function(carousel) {
      let dotsHtml = '',
        allDots = null;
      let dotNav = carousel.querySelector('.dot-nav');
      let scroller = carousel.querySelector('.items');
      let noOfSlides = carousel.querySelectorAll('.item').length;
      for (let i = 0; i < noOfSlides; i++) {
        dotsHtml += `<span data-id='${i}' class='${
          i == 0 ? 'active' : ''
        }'></span>`;
      }
      dotNav.innerHTML = dotsHtml;
      allDots = nodeListToArray(dotNav.childNodes);
      allDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          slide(scroller, dot.getAttribute('data-id'));
        });
      });
      scroller.addEventListener('scroll', function() {
        setActiveDot(carousel);
      });
    });
  };

  let setActiveDot = carousel => {
    let scroller = carousel.querySelector('.items');
    let activeDotNumber = Math.floor(
      scroller.scrollLeft / scroller.offsetWidth
    );
    let allDots = carousel.querySelectorAll('.dot-nav *');
    allDots = nodeListToArray(allDots);
    allDots.forEach(function(dot) {
      dot.classList.remove('active');
    });
    allDots[activeDotNumber].classList.add('active');
  };

  let slide = (carousel, pos = 0) => {
    var width = carousel.offsetWidth;
    carousel.scrollTo({
      left: width * pos,
      behavior: 'smooth'
    });
  };

  return {
    init: init
  };
})();

export default singleCarousel;
